import { Component, input, output } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton, MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';

@Component({
    selector: 'unite-loading-button',
    templateUrl: './loading-button.component.html',
    styleUrls: ['./loading-button.component.scss'],
    imports: [MatIconButton, MatTooltip, NgClass, MatIcon, MatProgressSpinner, MatButton]
})
export class LoadingButtonComponent {

  loading = input(false);
  text = input('');
  icon = input<string>(null);
  disabled = input(false);
  tooltip = input<string>(null);
  color = input('primary');

  matIconButton = input(false);
  matIconPosition = input<'prefix' | 'suffix'>('prefix');
  matStrokedButton = input(false);

  buttonClick = output();

  small = input(false);

}
